(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["th-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT = '[data-th-plp]';
    const KEY_COLS = 'th-plp-cols';
    const KEY_VIEW = 'th-plp-view';
    const timers = new WeakMap();

    const read = (key, fallback) => {
      try {
        return localStorage.getItem(key) || fallback;
      } catch (e) {
        return fallback;
      }
    };

    const write = (key, value) => {
      try {
        localStorage.setItem(key, value);
      } catch (e) {
        /* modalita privata: la preferenza vale solo per questa pagina */
      }
    };

    /* Riallinea griglia e bottoni alla preferenza salvata. */
    const apply = (root) => {
      const grid = root.querySelector('[data-th-grid]');
      if (!grid) return;
      const cols = read(KEY_COLS, root.dataset.defaultCols || '3');
      const view = read(KEY_VIEW, root.dataset.defaultView || 'grid');
      grid.dataset.cols = cols;
      grid.dataset.view = view;
      root.querySelectorAll('[data-th-cols]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.thCols === cols ? 'true' : 'false');
      });
      root.querySelectorAll('[data-th-view]').forEach((btn) => {
        btn.setAttribute('aria-pressed', btn.dataset.thView === view ? 'true' : 'false');
      });
      syncSide(root);
    };

    /* Il pulsante Filtro dice il vero a ogni larghezza: su desktop la colonna e
       aperta finche non la si chiude, su telefono e chiusa finche non la si apre. */
    const isDesktop = () => window.matchMedia('(min-width: 1024px)').matches;
    const syncSide = (root) => {
      const btn = root.querySelector('[data-th-side-toggle]');
      const side = root.querySelector('[data-th-side]');
      if (!btn || !side) return;
      const expanded = isDesktop()
        ? root.getAttribute('data-side-collapsed') !== 'true'
        : side.getAttribute('data-open') === 'true';
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    };

    const buildUrl = (root) => {
      const params = new URLSearchParams();
      const form = root.querySelector('[data-th-facets]');
      if (form) {
        new FormData(form).forEach((value, key) => {
          if (String(value).trim() !== '') params.append(key, value);
        });
      }
      const sort = root.querySelector('[data-th-sort]');
      if (sort && sort.value) params.set('sort_by', sort.value);
      const base = root.dataset.baseUrl || window.location.pathname;
      const query = params.toString();
      return query ? `${base}?${query}` : base;
    };

    /* Su desktop la pagina non scorre nella finestra ma dentro
       `.page-wrapper` (html e body sono overflow: hidden): window.scrollTo li'
       non fa niente. Si scorre il primo antenato che scorre davvero. */
    const scrollerOf = (el) => {
      for (let node = el.parentElement; node && node !== document.body; node = node.parentElement) {
        const overflow = getComputedStyle(node).overflowY;
        if ((overflow === 'auto' || overflow === 'scroll') && node.scrollHeight > node.clientHeight) return node;
      }
      return document.scrollingElement || document.documentElement;
    };

    const scrollIntoView = (root) => {
      const scroller = scrollerOf(root);
      const base = scroller === document.scrollingElement ? 0 : scroller.getBoundingClientRect().top;
      const top = root.getBoundingClientRect().top - base + scroller.scrollTop - 24;
      if (scroller.scrollTop > top) scroller.scrollTo({ top, behavior: 'smooth' });
    };

    const scrollToTop = (root) => {
      scrollerOf(root).scrollTo({ top: 0, behavior: 'auto' });
    };

    const render = async (url, root, push) => {
      const id = root.dataset.sectionId;
      if (!id) return;
      root.classList.add('th-plp--busy');
      const separator = url.indexOf('?') === -1 ? '?' : '&';
      try {
        const response = await fetch(`${url}${separator}section_id=${encodeURIComponent(id)}`);
        if (!response.ok) throw new Error(`HTTP ${response.status}`);
        const markup = await response.text();
        const next = new DOMParser().parseFromString(markup, 'text/html').querySelector(ROOT);
        if (!next) throw new Error('Sezione non trovata nella risposta');
        /* Il pannello filtri aperto su telefono e i gruppi come li aveva
           lasciati il visitatore. Si tiene l'elenco degli APERTI, non dei
           chiusi: da quando i gruppi nascono chiusi, ricordare i chiusi non
           serviva a niente e richiudeva a ogni spunta quello appena aperto. */
        const sideOpen = root.querySelector('[data-th-side]')?.getAttribute('data-open');
        const openFacets = Array.from(root.querySelectorAll('details.th-facet[open]')).map(
          (facet) => facet.dataset.facet
        );
        root.innerHTML = next.innerHTML;
        if (sideOpen) root.querySelector('[data-th-side]')?.setAttribute('data-open', sideOpen);
        root.querySelectorAll('details.th-facet').forEach((facet) => {
          facet.open = openFacets.indexOf(facet.dataset.facet) !== -1;
        });
        if (push) window.history.pushState({ thPlp: true }, '', url);
        apply(root);
      } catch (error) {
        /* Meglio una navigazione piena che una griglia bloccata. */
        console.error('[th-collection]', error);
        window.location.href = url;
        return;
      }
      root.classList.remove('th-plp--busy');
    };

    const submit = (root, delay) => {
      window.clearTimeout(timers.get(root));
      timers.set(
        root,
        window.setTimeout(() => {
          const url = buildUrl(root);
          render(url, root, true);
          scrollIntoView(root);
        }, delay)
      );
    };

    document.addEventListener('change', (event) => {
      const root = event.target.closest ? event.target.closest(ROOT) : null;
      if (!root) return;
      if (event.target.matches('[data-th-facets] input')) submit(root, 0);
      else if (event.target.matches('[data-th-sort]')) submit(root, 0);
    });

    document.addEventListener('input', (event) => {
      const root = event.target.closest ? event.target.closest(ROOT) : null;
      if (!root) return;
      if (event.target.matches('.th-facet__price')) submit(root, 600);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest ? event.target.closest('[data-th-facets]') : null;
      if (!form) return;
      event.preventDefault();
      submit(form.closest(ROOT), 0);
    });

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!target.closest) return;
      const root = target.closest(ROOT);
      if (!root) return;

      const colsBtn = target.closest('[data-th-cols]');
      if (colsBtn) {
        write(KEY_COLS, colsBtn.dataset.thCols);
        apply(root);
        return;
      }

      const viewBtn = target.closest('[data-th-view]');
      if (viewBtn) {
        write(KEY_VIEW, viewBtn.dataset.thView);
        apply(root);
        return;
      }

      const sideBtn = target.closest('[data-th-side-toggle]');
      if (sideBtn) {
        const side = sideBtn.closest('[data-th-side]');
        if (isDesktop()) {
          /* Sul root: sopravvive al ridisegno della sezione dopo un filtro. */
          const collapsed = root.getAttribute('data-side-collapsed') !== 'true';
          root.setAttribute('data-side-collapsed', collapsed ? 'true' : 'false');
        } else {
          const open = side.getAttribute('data-open') !== 'true';
          side.setAttribute('data-open', open ? 'true' : 'false');
        }
        syncSide(root);
        return;
      }

      const link = target.closest('a[data-th-link]');
      if (link) {
        event.preventDefault();
        /* Cambiare pagina e' come aprirne una nuova: si torna in cima, e solo
           dopo che la griglia nuova e' arrivata. Scorrendo prima, il ridisegno
           della griglia lasciava il visitatore giu' vicino alla paginazione. */
        if (link.closest('.th-pager')) {
          render(link.href, root, true).then(() => scrollToTop(root));
          return;
        }
        render(link.href, root, true);
        scrollIntoView(root);
      }
    });

    window.addEventListener('popstate', () => {
      document.querySelectorAll(ROOT).forEach((root) => render(window.location.href, root, false));
    });

    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll(ROOT).forEach(apply);
    });

    const boot = () => document.querySelectorAll(ROOT).forEach(apply);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
    else boot();
  })();

  } catch(e) { console.error(e); }
})();
})();
